import { DatePicker } from 'antd';
import dayjs from 'dayjs';

/**
 * Month picker for payroll periods. Stores `YYYY-MM` — the shape the server
 * uses for payroll runs. Display is `MMM YYYY` (Sep 2026) because payroll is
 * spoken about by month name, not by ISO string.
 */
interface Props {
  value?: string;
  onChange?: (value: string | undefined) => void;
  disabled?: boolean;
  placeholder?: string;
  status?: 'error' | 'warning';
  id?: string;
}

export function MonthField({ value, onChange, placeholder, ...rest }: Props) {
  const parsed = value ? dayjs(value, 'YYYY-MM', true) : null;
  const dayjsValue = parsed && parsed.isValid() ? parsed : null;

  return (
    <DatePicker
      picker="month"
      value={dayjsValue}
      onChange={(d) => onChange?.(d ? d.format('YYYY-MM') : undefined)}
      format="MMM YYYY"
      placeholder={placeholder ?? 'Pick month'}
      allowClear
      style={{ width: '100%' }}
      {...rest}
    />
  );
}
